import Div from "@jumbo/shared/Div/Div";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import {useEffect, useState} from "react";
import {get} from "../../../common/network";


const NotesTab = ({id, onSubmit}) => {
    const [note, setNote] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await get(`docgen/matters/${id}`);
                setNote(response?.data?.notes);
            } catch (error) {
            }
        };
        fetchData();
    }, [id]);

    return (
        <Div>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit(note);
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="message" className="mb-2 fs-6">Notes</label>
                                <Div
                                    sx={{
                                        position: "relative",
                                        "& .pencil-icon-btn": {
                                            position: "absolute",
                                            bottom: "15px",
                                            right: "17px",
                                            p: 0
                                        },
                                        "& .pencil-icon": {
                                            fontSize: "25px"
                                        },
                                        "& .form-control": {
                                            pr: "22px"
                                        }
                                    }}
                                >
                                    <TextareaAutosize
                                        disabled
                                        maxRows={4}
                                        minRows={4}
                                        aria-label="maximum height"
                                        className="form-control shadow-none"
                                        id="message"
                                        name="message"
                                        label="message"
                                        value={note}
                                        onChange={(e) => {
                                            setNote(e.target.value);
                                        }}
                                    />
                                </Div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Div>
    );
};


export default NotesTab;